import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default ({
    namespaced: true,

    state: {
        haberes: [],
    },
    getters: {
        haberes(state) {
            return state.haberes
        }
    },
    mutations: {
        setHaberes(state, payload) {
            state.haberes = payload
        }
    },
    actions: {

        async getReciboHaberes({ commit, dispatch }, data) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/obtenerHaberes',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                },
                data: JSON.stringify(data)
            }).then((response) => {
                const res = response.data.haberes
                commit('setHaberes', res)
            }).catch(function (error) {
                console.log(error)
            }).finally(() => {
                dispatch('auth/setSktLoader', false, { root: true })

            })
        },


        imprimirPdf({ commit, dispatch }, data) {
            var url
            var id = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
            var l = Math.floor(Math.random() * 100);
            var t = Math.floor(Math.random() * 100);
            var url = process.env.VUE_APP_HABERES

            var form = document.createElement("form");
            form.action = url;
            form.method = 'POST';
            form.target = id;


            for (var key in data) {
                var input = document.createElement("textarea");
                input.name = key;
                input.value = typeof data[key] === "object" ? JSON.stringify(data[key]) : data[key];
                form.appendChild(input);
            }
            form.style.display = 'none';
            document.body.appendChild(form);
            //window.open('', id, 'scrollbars=no,menubar=no,height=600,width=800,resizable=yes,toolbar=no,status=no,left=' + l + ',top=' + t);
            //console.log(form)
            form.submit();
        },
    },
})